import PatientBillOfRights from "../pages/PatientBillOfRights";
import { ROUTES } from './routes.config';

export const PatientBillOfRightsRoutes = {
  path: ROUTES.PATIENTS_BILL_OF_RIGHTS,
  element: <PatientBillOfRights />,
};
  
